<template xmlns="http://www.w3.org/1999/html">
    <div>
        <div :class="{'disabled': !isActive}">
            <a class="reward-item-a" @click="open">
                <div class="reward-item-box panel" style="text-align: center;">
                    <div class="col-md-12 product-image" :style="getBackgroundImage()"></div>
                    <div class="col-12">
                        <div class="product-title">{{ rewardGroupTitle }}</div>
                    </div>
                  <div v-if="rewardGroupIsLimited" class="available-rewards">
                    <div v-if="!outOfStock">Noch {{ amountOfAvailableRewards }} verfügbar <br>im {{ availableDate}}.</div>
                    <div v-if="outOfStock">Nicht verfügbar</div>
                  </div>
                  <div class="reward-price">
                    <div class="reward-price__prices">
                      <div class="reward-price__value" :class="{'reward-price__value--coding-weekend': showCodingWeekendWidget}">
                        <div v-if="this.minPrice === this.maxPrice">{{ this.minPrice }}</div>
                        <div v-if="this.minPrice !== this.maxPrice">{{ this.minPrice }} - {{ this.maxPrice }}</div>
                      </div>
                      <div v-if="showCodingWeekendWidget" class="reward-price__value reward-price__value--discount">{{ minPrice }} - {{ maxPrice }}</div>
                    </div>
                    <div class="reward-price__icon">
                      <img src="/assets/img/coins.png"/>
                    </div>
                  </div>
                </div>
            </a>
        </div>
        <RewardExchangeView
                :uuid="uuid"
                :title="title"
                :description="description"
                :minPrice="minPrice"
                :maxPrice="maxPrice"
                :logo="logo"
                :rewards="rewards"
                :openSwitch="isExchangeDialogOpened"
                :closeHandler=close
        />
    </div>
</template>

<script>
    import RewardExchangeView from "./RewardExchangeComponent";
    import {services} from "../../main.js"
    import {eventBus} from "../../main.js"

    export default {
        name: "RewardGroupComponent",
        components: {RewardExchangeView},
        props: {
            uuid: {type: [String], default: ''},
            title: {type: [String], default: ''},
            description: {type: [String], default: ''},
            logo: {type: [String], default: null},
            minPrice: {type: [Number], default: 0},
            maxPrice: {type: [Number], default: 0},
            isActive: {type: [Boolean], default: true},
            showRewardValueInTitle: {type: [Boolean], default: false},
            rewards: {type: [Array], default: () => []}
        },
        data() {
            return {
                isExchangeDialogOpened: false,
                userCoinsApiResult: services.rewardService.getUserCoins(),
                showCodingWeekendWidget:window.CODING_WEEKEND_FEATURE_FLAG,
            }
        },
        computed: {
          rewardGroupTitle() {
            if (this.showRewardValueInTitle) {
              if (this.rewards.every((reward) => reward.valueInEuro <= 0)) {
                return this.title;
              }
              let min = Math.min(...this.rewards.map(reward => reward.valueInEuro));
              let max = Math.max(...this.rewards.map(reward => reward.valueInEuro));
              if (min === max) {
                return this.title + " " + min + "€";
              }
              return this.title + " " + min + " - " + max + "€";
            }
            return this.title;
          },
          rewardGroupIsLimited() {
            return this.rewards.every((reward) => reward.amountOfRewards !== null);
          },
          outOfStock() {
            return this.rewards.every((reward) => reward.remainingRewards <= 0);
          },
          availableDate() {
            const date = new Date();
            const month = date.toLocaleString('de-DE', { month: 'long' });
	          return `${month}`;
          },
          amountOfAvailableRewards() {
            let amount = 0;
            if (this.rewardGroupIsLimited) {
              for (let reward of this.rewards) {
                if (reward.remainingRewards > 0) {
                  amount += reward.remainingRewards;
                }
              }
            }
            return amount;
          },
        },
        created() {
            let reward = this.$route.query.reward;
            if (reward === this.uuid) {
                this.isExchangeDialogOpened = true;
            }
        },
        methods: {
            getBackgroundImage() {
                return 'background-image: url("' + this.logo + '");'
            },
            open() {
                this.$router.replace({
                    query: {
                        reward: this.uuid
                    }
                });
                this.isExchangeDialogOpened = true;
            },
            close() {
                this.isExchangeDialogOpened = false;
                this.$router.replace({
                    query: {
                        reward: null
                    }
                });
            },
            getDisocount() {
              if (window.CODING_WEEKEND_FEATURE_FLAG) {
                return Math.ceil(this.minPrice * 100 / 75) - this.minPrice;
              }
              return 0;
            }
        }
    }
</script>

<style scoped>
    .product-image {
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        height: 120px;
        margin-top: 4rem;
        margin-bottom: 1.5rem;
    }

    .reward-item-box {
        border-radius: 8px;
        margin: 15px 0;
        padding: 2rem 0;
        border:none;
        transition: all 200ms linear;
    }

    .reward-item-box:hover {
      box-shadow: 0 16px 40px rgba(13, 51, 85, 0.3);
    }

    .product-title {
        margin: 1rem 0;
        font-size: 1.8rem;
    }

    .reward-item-a{
        text-decoration: none;
    }

    .reward-price {
        position: absolute;
        top: 3rem;
        right: 3rem;
    }

    a {
        cursor: pointer;
    }
    .disabled {
        opacity: 0.5;
    }
    .disabled a {
        text-decoration: none;
        color: black;
    }

    .reward-price__value.reward-price__value--coding-weekend {
      text-decoration: line-through;
      opacity: 0.4;
      font-size: 11px;
      line-height: 0.8;
      text-align: right;
    }

    .reward-price {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
    }

    .reward-price__icon {
      margin-left: 0.5rem;
    }

    .reward-price__icon img {
      height: 2.5rem;
    }

    .reward-price__value {
      font-size: 16px;
    }

    .available-rewards {
      position: absolute;
      top: 3.25rem;
      left: 3rem;
      display: flex;
      align-items: center;
      text-align: left;
      color: #e74c3c;
    }
</style>
